import script from "./ConfigEcommerce.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigEcommerce.vue?vue&type=script&setup=true&lang=js"

import "./ConfigEcommerce.vue?vue&type=style&index=0&id=5bcf67a6&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcf67a6"]])

export default __exports__